"use client";

import React from "react";

interface SearchLoadingSkeletonProps {
  count?: number;
}

export function SearchLoadingSkeleton({ count = 5 }: SearchLoadingSkeletonProps) {
  return (
    <div className="space-y-4 px-6 py-4">
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="space-y-3 animate-pulse">
          {/* Group header skeleton */}
          {index === 0 && (
            <div className="px-4 py-2 bg-gray-100 rounded h-6 w-32 mb-4" />
          )}

          {/* Result skeleton */}
          <div className="flex items-start space-x-4 p-4 bg-gray-50 rounded-lg">
            {/* Icon */}
            <div className="flex-shrink-0 h-4 w-4 bg-gray-200 rounded" />

            {/* Content */}
            <div className="flex-1 space-y-2 min-w-0">
              {/* Title */}
              <div className="h-4 bg-gray-200 rounded w-3/4" />

              {/* Subtitle */}
              <div className="h-3 bg-gray-100 rounded w-1/2" />

              {/* Content preview */}
              <div className="space-y-1">
                <div className="h-3 bg-gray-100 rounded w-full" />
                <div className="h-3 bg-gray-100 rounded w-5/6" />
              </div>

              {/* Tags */}
              <div className="flex space-x-2 pt-2">
                <div className="h-5 bg-gray-200 rounded-full w-16" />
                <div className="h-5 bg-gray-200 rounded-full w-16" />
              </div>
            </div>

            {/* Status badge */}
            <div className="flex-shrink-0 h-6 w-16 bg-gray-200 rounded-full" />
          </div>
        </div>
      ))}
    </div>
  );
}
